import React from 'react'

import {
    HeaderWrapper,
    HeaderInner,
    DesktopLogo,
    MobileLogo,
    CTAWrapper,
} from '@/components/header/header.styles'
import Button from '@helios/shared/components/button'
import LocalizedLink from '@helios/shared/components/localized-link'
import type {Props as PrismicLinkProps} from '@helios/shared/components/prismic-link'
import PrismicLink from '@helios/shared/components/prismic-link'
import logoAngled from '@helios/shared/images/icons/logo-angled.svg'
import logoHorizontal from '@helios/shared/images/icons/logo-horizontal.svg'
import {useGlobalStrings} from '@helios/shared/providers/global-strings'

interface Props {
    ctaText: string
    ctaLink: PrismicLinkProps
}

const Header = ({ctaText, ctaLink}: Props) => {
    const {home} = useGlobalStrings()

    // `HeaderWrapper` extends `RemoveScroll` so we need to disable the overflow hiding
    return (
        <HeaderWrapper enabled={false}>
            <HeaderInner>
                <DesktopLogo>
                    <LocalizedLink to="/">
                        <img src={logoAngled} alt={home} />
                    </LocalizedLink>
                </DesktopLogo>

                <MobileLogo>
                    <LocalizedLink to="/">
                        <img src={logoHorizontal} alt={home} />
                    </LocalizedLink>
                </MobileLogo>

                <CTAWrapper>
                    <Button as={PrismicLink} {...ctaLink}>
                        {ctaText}
                    </Button>
                </CTAWrapper>
            </HeaderInner>
        </HeaderWrapper>
    )
}

export default Header
